import { GetSitecoreRoutes } from './SitecoreRoutes.service';
import { Route } from '@maverick/ui';

export type NavigationRendering = {
	dataSource: string;
	language: string;
	fields: {
		[NavigationField.Primary]: { value: string };
		[NavigationField.Secondary]: { value: string };
		[NavigationField.Terciary]: { value: string };
	};
};

export enum NavigationField {
	Primary = 'Primary Navigation',
	Secondary = 'Secondary Navigation',
	Terciary = 'Terciary Navigation',
}

enum NavigationVariant {
	Primary = 'primary',
	Secondary = 'secondary',
	Terciary = 'terciary',
}

const NavigationItems = async (rendering: NavigationRendering): Promise<Array<Route>> => {
	const routes = await GetSitecoreRoutes(rendering?.dataSource, rendering.language);

	const pages = new Array<Route>();
	setPages(NavigationVariant.Primary);
	setPages(NavigationVariant.Secondary);
	setPages(NavigationVariant.Terciary);
	return pages;

	function setPages(variant: NavigationVariant) {
		getIds().forEach((i) => {
			const item = routes.find((route) => route.id === i)!;
			if (!!item) pages.push({ ...item, variant });
		});

		function getIds(): string[] {
			return ((rendering.fields[getField()] as any).value as string)
				.split('|')
				.map((i) => i.replace('{', '').replace('}', '').replaceAll('-', ''));

			function getField(): NavigationField {
				switch (variant) {
					case NavigationVariant.Primary:
						return NavigationField.Primary;
					case NavigationVariant.Secondary:
						return NavigationField.Secondary;
					case NavigationVariant.Terciary:
						return NavigationField.Terciary;
				}
			}
		}
	}
};

export const NavigationRoutes = {
	Routes: NavigationItems,
};
